// The 1-year outlook's label, from the chance of a rise: one rule for the area panel, the rate what-if, the Screener's
// outlook filter, market pages, the report and the emails (the API sends the label; pages read it back with outlookOf).

export type Outlook = "up" | "unclear" | "down";

/** Leaning up at a chance of a rise of 2/3 or more, leaning down at 1/3 or less, otherwise no clear direction. */
export const LEANING_UP = 2 / 3;
export const LEANING_DOWN = 1 / 3;

export const OUTLOOK = {
  up: { label: "Leaning up", arrow: "↗" },
  unclear: { label: "No clear direction", arrow: "→" },
  down: { label: "Leaning down", arrow: "↘" },
} as const satisfies Record<Outlook, { label: string; arrow: string }>;

export type OutlookLabel = (typeof OUTLOOK)[Outlook]["label"];

export const outlook = (pRise: number | null | undefined): Outlook | null =>
  pRise == null ? null : pRise >= LEANING_UP ? "up" : pRise <= LEANING_DOWN ? "down" : "unclear";

export const outlookLabel = (pRise: number | null | undefined): OutlookLabel | null => {
  const o = outlook(pRise);
  return o ? OUTLOOK[o].label : null;
};

/** The outlook an API label stands for. */
export const outlookOf = (label: string | null | undefined): Outlook | null =>
  (Object.keys(OUTLOOK) as Outlook[]).find((k) => OUTLOOK[k].label === label) ?? null;

/** SQL condition for an outlook on a chance-of-a-rise column (rounded like the API's values, so a filter agrees with the label). */
export function outlookSql(col: string, o: Outlook): string {
  const p = `round(${col}, 6)`;
  return o === "up" ? `${p} >= ${LEANING_UP}` : o === "down" ? `${p} <= ${LEANING_DOWN}` : `${p} > ${LEANING_DOWN} AND ${p} < ${LEANING_UP}`;
}
